module.exports = __webpack_public_path__ + "img/G944747822.8efece6.webp";